import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import * as types from './mutation-types';

export function fetchQuizPage({ dispatch }, id) {
  return http.get(`${MINERVA_API_URL}/pages/${id}`)
    .then(resp => (dispatch('setQuizPage', resp.data)))
    .catch(err => Promise.reject(err));
}

export function fetchCardPageAtPosition({ dispatch, getters }) {
  const params = getters.getRouteParams;
  return http.get(`${MINERVA_API_URL}/cards/${params.cardId}/pages`)
    .then(resp => (dispatch('setQuizPage', resp.data[params.pagePosition - 1])))
    .catch(err => Promise.reject(err));
}

export function setQuizPage({ commit }, quiz) {
  commit(types.SET_QUIZ_PAGE, quiz);
}

export function fetchVideoLecture({ dispatch }, id) {
  return http.get(`${MINERVA_API_URL}/video-lectures/${id}`)
    .then(resp => (dispatch('setVideoLecture', resp.data)))
    .catch(err => Promise.reject(err));
}

export function setVideoLecture({ commit }, videoLecture) {
  commit(types.SET_VIDEO_LECTURE, videoLecture);
}
